import React, { memo } from "react";
import PropTypes from "prop-types";
import {
	RowBadge,
	RowControl,
	RowDescription,
	RowLabel,
	RowRoot,
	RowTitle,
} from "./elements";

export const BettoSettingsRow = memo(({ label, description, control, badge }) => (
	<RowRoot>
		<RowLabel>
			<RowTitle>{label}</RowTitle>
			{description ? <RowDescription>{description}</RowDescription> : null}
		</RowLabel>
		<RowControl>{badge ? <RowBadge>{badge}</RowBadge> : null}{control}</RowControl>
	</RowRoot>
));

BettoSettingsRow.displayName = "BettoSettingsRow";

BettoSettingsRow.propTypes = {
	label: PropTypes.node.isRequired,
	description: PropTypes.node,
	control: PropTypes.node,
	badge: PropTypes.node,
};
